import { FunctionComponent, useEffect } from "react";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import { Columns } from "../../Components/Table/ITable";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import TableSearch from "../../Components/Table/components/TableSearch";
import { getScreenList } from "../../Redux/Slices/Screen/ScreenList";
import { Box, Typography, Paper } from "@mui/material";
import { ISideMenu } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";

interface Screen {
    screen_id: string;
    name: string;
    path: string;
    url: string;
    icon: string;
    screen_order: number;
    status: boolean;
    delete_flag: boolean;
}

const ScreenMaster: FunctionComponent = () => {
    const dispatch = useAppDispatch();
    const { data: screenData, isLoading } = useAppSelector(
        (state) => state.ScreenList
    );

    // user permission logic (pattern from Role.tsx)
    const userPermissionlist = useAppSelector(
        (state) => (state.SideMenuPermission as ISideMenu).data
    );

    const to = "settings";
    const filteredList = userPermissionlist?.Dashboard?.filter(
        (item: any) => item.to === to
    ) || [];
    const fliterdata: any = filteredList[0]?.items || [];
    // Finding the screen master specific permission if needed, 
    // but following Role.tsx exactly which takes the first item of fliterdata
    // In Role.tsx it was finaldata = fliterdata[0];
    const finaldata = fliterdata.find((item: any) => item.to === "screen") || fliterdata[0];

    const columns: Columns = [
        {
            field: "index",
            renderHeader: () => <b>S.No</b>,
            width: 90,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "name",
            renderHeader: () => <b>Screen Name</b>,
            flex: 1,
            type: "string",
            headerAlign: "left",
        },
        {
            field: "path",
            renderHeader: () => <b>Path</b>,
            flex: 1,
            type: "string",
            headerAlign: "left",
            renderCell: (params) => (
                <Typography
                    variant="body2"
                    sx={{
                        fontFamily: "monospace",
                        backgroundColor: "#f0f0f0",
                        padding: "4px 8px",
                        borderRadius: 1,
                        display: "inline-block",
                    }}
                >
                    {params.value || "-"}
                </Typography>
            ),
        },
        {
            field: "status",
            renderHeader: () => <b>Status</b>,
            flex: 1,
            type: "string",
            headerAlign: "left",
            cellClassName: (params) =>
                `activename ${params.row.status ? "active" : "inactive"}`,
            valueFormatter: (params) =>
                params.value === true ? "Active" : "Inactive",
        },
    ];

    const screens = Array.isArray(screenData?.data)
        ? (screenData?.data || []).map((screen: Screen, index: number) => ({
            ...screen,
            index: index + 1,
        }))
        : [];

    useEffect(() => {
        dispatch(getScreenList());
    }, [dispatch]);

    return (
        <>
            <Table
                rows={screens}
                columns={columns}
                exportFileName="Screens"
                loading={isLoading}
                getRowId={(row) => row.screen_id}
                sx={{
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
                    borderRadius: 2,
                }}
            >
                <CustomToolbar>
                    <Typography variant="h6" component="h6"></Typography>
                    <TableSearch />
                    {/* Add buttons here if needed in future, following Role.tsx pattern */}
                </CustomToolbar>
            </Table>
        </>
    );
};

export default ScreenMaster;
